<template>
    <div>
        <v-card color="grey lighten-3" class="my-3 mx-2">
            <v-card-title
                class="
                    secondary
                    white--text
                    text-uppercase text-subtitle-2
                    py-2
                "
                dark
                >{{ item.codeDegree }}</v-card-title
            >
            <v-card-text class="mt-2">
                <div
                    class="d-flex my-1"
                    v-for="(row, index) in rowItems"
                    :key="index"
                >
                    <span
                        style="width: 180px"
                        class="d-inline font-weight-bold text-uppercase"
                        >{{ row.label }}:</span
                    >
                    <span
                        :class="$_.get(row, 'class', '')"
                        v-if="$_.get(row, 'type', 'text') === 'text'"
                        >{{ $_.get(item, row.key) }}</span
                    >
                    <v-chip
                        v-else
                        :class="$_.get(row, 'class', '')"
                        small
                        color="secondary darken-2"
                        >{{ $_.get(item, row.key) }}</v-chip
                    >
                </div>
            </v-card-text>
        </v-card>
        <v-card color="grey lighten-3" class="my-3 mx-2">
            <v-card-title
                class="
                    secondary
                    white--text
                    text-uppercase text-subtitle-2
                    py-2
                "
                dark
                >History</v-card-title
            >
            <v-card-text class="mt-2">
                <div
                    class="d-flex my-2 align-center"
                    v-for="(history, j) in item.histories"
                    :key="`history-${j}`"
                >
                    <v-chip label color="secondary" class="mr-4">{{
                        history.sequenceNumber
                    }}</v-chip>
                    <div>
                        <span class="d-inline"
                            >Degree:
                            <strong>{{ history.codeDegree }}</strong>
                            | Stage:
                            <strong>{{ history.codeOffenseStage }}</strong>
                            |
                            {{ history.offenseDescription }}
                        </span>
                        <br />
                        <span class="d-inline"
                            >Statute:
                            <strong>{{ history.statute }}</strong>
                        </span>
                    </div>
                </div>
            </v-card-text>
        </v-card>
        <v-card color="grey lighten-3" class="my-3 mx-2">
            <v-card-title
                class="
                    secondary
                    white--text
                    text-uppercase text-subtitle-2
                    py-2
                "
                dark
                >Pleas</v-card-title
            >
            <v-card-text class="mt-2">
                <psi-simple-table
                    :items="getChargePleas(item.pleas)"
                    :headers="headers"
                ></psi-simple-table>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            rowItems: [
                {
                    key: "chargeNumber",
                    label: "Charge Number",
                },
                {
                    key: "codeAgency",
                    label: "Agency",
                },
                {
                    key: "codeDegree",
                    label: "Degree",
                    type: "chip",
                    class: "text-uppercase",
                },
                {
                    key: "description",
                    label: "Description",
                },
                {
                    key: "offenseDate",
                    label: "Offense Date",
                },
                {
                    key: "disposition.codeCrimeDispType",
                    label: "Disposition",
                    type: "chip",
                    class: "text-uppercase",
                },
                {
                    key: "disposition.codeDispJudge",
                    label: "Judge",
                },
                {
                    key: "disposition.dispositionDate",
                    label: "Disposition Date",
                },
            ],
        };
    },
    computed: {
        headers() {
            return [
                {
                    title: "Date",
                    key: "PleaDate",
                },
                {
                    title: "Plea Type",
                    key: "CodePleaType",
                },
                {
                    title: "Plea Judge",
                    key: "CodePleaJudge",
                },
            ];
        },
    },
    methods: {
        getChargePleas(pleas) {
            return pleas.map((plea) => {
                return {
                    ...plea,
                    PleaDate: plea.PleaDate.split(" ").shift(),
                };
            });
        },
    },
};
</script>

<style lang="scss" scoped>
</style>